import { useEffect, useState } from "react";
import { type NodeKey } from "lexical";
import { InformationCircleIcon } from "vega-icons";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { TooltipInfoIcon } from "@vega-core/components/Tooltip/TooltipInfoIcon";

import { useAnnotationContext } from "./annotationContext";

type Props = {
  nodeKey: NodeKey;
  content: string;
};

export function TooltipNodeView({ nodeKey, content }: Props) {
  const [editor] = useLexicalComposerContext();
  const annotation = useAnnotationContext();
  const [isEditable, setIsEditable] = useState(() => editor.isEditable());

  useEffect(() => editor.registerEditableListener(setIsEditable), [editor]);

  if (!isEditable) {
    return (
      <TooltipInfoIcon
        className="ml-1 inline-block align-middle"
        content={content}
      />
    );
  }

  return (
    <button
      className="ml-1 inline-flex cursor-pointer align-middle text-text/secondary hover:text-text/primary"
      contentEditable={false}
      data-testid="tooltip-marker"
      onClick={() => annotation?.openEdit("tooltip", nodeKey, content)}
      type="button"
    >
      <InformationCircleIcon className="size-4" />
    </button>
  );
}
